// extracted by mini-css-extract-plugin
export default {"maincontainer":"Portfolio_maincontainer__6dVJs"};